import React from 'react';
import type { Notification } from '../api/notifications';

interface NotificationItemProps {
    notif: Notification;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ notif }) => {
    
    // Déterminer la couleur selon le type
    let typeClass = 'badge-ghost';
    let borderClass = 'border-l-4 border-l-base-300';

    switch (notif.type) {
        case 'error':
            typeClass = 'badge-error';
            borderClass = 'border-l-4 border-l-error';
            break;
        case 'warning':
            typeClass = 'badge-warning';
            borderClass = 'border-l-4 border-l-warning';
            break;
        case 'success':
            typeClass = 'badge-success';
            borderClass = 'border-l-4 border-l-success';
            break;
        case 'info':
            typeClass = 'badge-info';
            borderClass = 'border-l-4 border-l-info';
            break;
    }

    // Badge de statut lu/non lu
    const statusClass = notif.is_read ? 'badge-outline' : 'badge-warning';

    // Formater la date
    const formattedDate = new Date(notif.created_at).toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });

    return (
        <div className={`p-4 mb-3 ${notif.is_read ? 'bg-base-200/50' : 'bg-base-200'} rounded-lg shadow-sm ${borderClass} transition duration-150 hover:bg-base-300`}>
            <div className="flex justify-between items-start">
                <div className="flex flex-col gap-1">
                    <p className={`font-semibold text-sm leading-tight ${notif.is_read ? 'text-base-content/60' : 'text-base-content'}`}>{notif.title}</p>
                    <p className={`text-xs leading-snug ${notif.is_read ? 'text-base-content/50' : 'text-base-content/80'}`}>{notif.message}</p>
                </div>
                <span className={`badge badge-sm ml-3 ${typeClass} whitespace-nowrap`}>
                    {notif.type.toUpperCase()}
                </span>
            </div>
            
            <p className="text-xs text-base-content/60 mt-1">Reçu le : {formattedDate}</p>
            
            {!notif.is_read && (
                <div className="mt-2">
                    <span className={`badge badge-xs ${statusClass}`}>Nouvelle</span>
                </div>
            )}
        </div>
    );
};

export default NotificationItem;